enum ELocationStatus {
  Live = 0,
  ReadOnly = 1,
  Inactive = 2
}

export const SearchableStatuses: readonly string[] = Object.freeze([
  ELocationStatus.Live.toString(),
  ELocationStatus.ReadOnly.toString()
]);

export default ELocationStatus;
